import React from 'react';
import { Language, translations } from '../utils/translations';
interface QRCodeBlockProps {
  theme: string;
  mode: string;
  lang: Language;
}
export function QRCodeBlock({
  theme,
  mode,
  lang
}: QRCodeBlockProps) {
  const t = translations[lang];
  // Construct the current URL with parameters
  const currentUrl = typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}?theme=${theme}&mode=${mode}&lang=${lang}` : '';

  // Generate QR code using a reliable free API
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(currentUrl)}&margin=1`;
  return <section className="flex flex-col items-center gap-4 rounded-[22px] border border-zinc-800 bg-zinc-900 p-5 shadow-lg" data-id="element-169" data-mp="18078xphn1jfm">
      <h2 className="text-[15px] font-bold text-zinc-50 text-center" data-id="element-170" data-mp="1czac14e25fky">
        {t.qrTitle}
      </h2>
      <div className="rounded-xl bg-white p-3 shadow-sm" data-id="element-171" data-mp="37bi489yzvid1">
        <img src={qrUrl} alt="QR Code" className="h-32 w-32 object-contain" loading="lazy" data-id="element-172" data-mp="37ayl4pxlynxf" />
      </div>
      <p className="text-center text-[13px] text-zinc-400" data-id="element-173" data-mp="32n3irme4a7ne">
        {t.qrDesc}
      </p>
    </section>;
}